import { detectDeviceCapabilities } from '@/utils/deviceTier';

export function UnsupportedBrowser() {
  const caps = detectDeviceCapabilities();

  return (
    <div className="flex h-full flex-col items-center justify-center px-4 bg-gradient-radial-blue">
      <div className="w-full max-w-sm text-center glass-strong rounded-3xl p-8 shadow-3d-card animate-slide-up">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-50 ring-4 ring-amber-50/80">
          <svg
            className="h-8 w-8 text-amber-500"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
            />
          </svg>
        </div>

        <h2 className="mb-2 text-xl font-bold text-slate-900">Browser Not Supported</h2>
        <p className="mb-4 text-sm leading-relaxed text-slate-500">
          Your browser doesn't support the features needed to run the visualizer.
        </p>

        <div className="mb-6 rounded-2xl bg-slate-50/80 border border-slate-100 p-4 text-left text-sm">
          <p className="mb-2 font-semibold text-slate-700">Detected capabilities:</p>
          <ul className="space-y-1.5 text-slate-500">
            <li className="flex items-center gap-2">
              <span
                className={`h-2 w-2 rounded-full ${caps.webgpuSupported ? 'bg-emerald-500' : 'bg-red-400'}`}
              />
              WebGPU: {caps.webgpuSupported ? 'Supported' : 'Not supported'}
            </li>
            <li className="flex items-center gap-2">
              <span
                className={`h-2 w-2 rounded-full ${caps.canvas2dSupported ? 'bg-emerald-500' : 'bg-red-400'}`}
              />
              Canvas 2D: {caps.canvas2dSupported ? 'Supported' : 'Not supported'}
            </li>
          </ul>
        </div>

        <p className="mb-4 text-sm text-slate-500">Please use one of these browsers:</p>

        <div className="flex justify-center gap-3">
          {[
            { label: 'Chrome', href: 'https://www.google.com/chrome/' },
            { label: 'Firefox', href: 'https://www.mozilla.org/firefox/' },
            { label: 'Safari', href: 'https://www.apple.com/safari/' },
          ].map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-xl bg-bss-blue-50 border border-bss-blue/10 px-4 py-2 text-sm font-semibold text-bss-blue transition-all hover:bg-bss-blue hover:text-white hover:-translate-y-0.5"
            >
              {label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
